import deductions from "./deductions";

export default [deductions];
